module.exports = __webpack_public_path__ + "img/d-xiuchang-nv.e5fa883f.jpg";